import {createContext} from 'react';

import {TDiagonalWrapperConfig} from 'components/layout-components/DiagonalWrapper/DiagonalWrapper';

export const DiagonalWrapperContext = createContext<TDiagonalWrapperConfig>(
  {} as TDiagonalWrapperConfig,
);
